module.exports = {
    projectId: "v6znmvbg",
    dataset: "production",
};
